import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../../Webservices/api';


export const fetchPeriods = createAsyncThunk(
  "periods/fetchPeriods",
  async (_, thunkAPI) => {
    const state = thunkAPI.getState();

    const schoolId = state.masterData.school_id;
    const userId = state.authSlice.user.id;
    const isIndividualLogin = state.authSlice?.user.roles === 'teacher' || state.authSlice?.user.roles === 'guest_user';

    const response = await api.get(
      `/periods/${schoolId}`,
      {
        params: userId && isIndividualLogin ? { user_id: userId } : {},
      }
    );

    console.log("Periods API response:", response.data);

    return response.data;
  }
);

export const createPeriodSetup = createAsyncThunk(
  'periods/createPeriodSetup',
  async (periodData) => {
    const response = await api.post(`/periods/setup`, periodData);
    return response.data;
  }
);

const periodSlice = createSlice({
  name: 'periods',
  initialState: {
    periods: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchPeriods.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchPeriods.fulfilled, (state, action) => {
        state.loading = false;
        state.periods = action.payload;
      })
      .addCase(fetchPeriods.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(createPeriodSetup.fulfilled, (state, action) => {
        state.periods = action.payload;
      });
  },
});

export default periodSlice.reducer;
